import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomHttp } from '../../../common/customHttp.service';
import { ApiUrl } from '../../../common/apiUrls';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MainAppComponent } from '../../../layout/layout.component';
import { AnalysisSectionSearchModel } from '../../../common/viewModels/ReportConfig/productgradesModel';
import { PagerService } from '../../../common/pagerService';
import { ValidationService } from '../../../common/validationservice';
import { AmplifyService } from '../../../common/amplify-service';
declare var $: any;

@Component({
    selector: 'analysisreportconfiglist',
    templateUrl: './analysisrepconfig.component.html',
    styleUrls: ['./analysisrepconfig.component.scss']
})
export class AnalysisReportListComponent implements OnInit {
    analysisReportForm: FormGroup;
    analysisReportSearchForm: FormGroup;
    isNoRecords: boolean = true;
    searchFields: AnalysisSectionSearchModel = new AnalysisSectionSearchModel();
    lstCustomers: any[];
    pager: any = {};
    pagedItems: any[];
    lstSampleTypes: any[];
    length: number = 0;
    isSubmitted: boolean = false;
    disableAddBtn: false;
    id: number;
    mainComponent: any;
    constructor(public _router: Router, private _formBuilder: FormBuilder,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _toastrService: ToastrService,
        private _validationService: ValidationService,
        private _mApp: MainAppComponent, private _pagerService: PagerService,
        private _amplifyService: AmplifyService
    ) {
        this.mainComponent = _mApp;
    }

    ngOnInit() {
        this.pager.pageSize = localStorage.getItem('PageSize') ? parseInt(localStorage.getItem('PageSize')) : 10;
        this.pager.pageIndex = 0;
        this.pager.pageSizeOptions = this._pagerService.pageSizeOptions;
        this.analysisReportSearchForm = this._formBuilder.group({
            // CustomerId: [''],
            Name: [''],
            SampleTypeId: [''],

            ReportParameter: [''],
        });
        this.CreateForm();
        this.GetCustomers();
        this.GetSampleTypes();
        this.GetDataFromAmpliy();
        this.setPage(this.pager);
        this.ClearDataInAmplify();
        
    }

    CreateForm() {
        this.analysisReportForm = this._formBuilder.group({
            // CustomerId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])],
            OrderId: ['', Validators.compose([Validators.required, Validators.min(1), Validators.max(50)])],
            Name: ['', Validators.compose([Validators.required, Validators.minLength(1), Validators.maxLength(50)])],
            SampleTypeId: ['', Validators.compose([Validators.required, this._validationService.ValidateDropdownList])]
        });
    }

    setPage(page: any) {
        this.pager.pageSize = page.pageSize;
        this.pager.pageIndex = page.pageIndex;
        this.GetAnalysisSections(this.pager);
    }

    AddAnalysisReport() {
        this._router.navigate(['/addproductgrades']);
    }

    onSearchSubmit() {
        this.pager.pageIndex = 0;
        this.ConstructSearchData();
        this.setPage(this.pager);

    }

    ConstructSearchData() {
        let searchDto = this.analysisReportSearchForm.value;
        this.searchFields.CustomerId = searchDto.CustomerId;
        this.searchFields.SampleTypeId = searchDto.SampleTypeId;
        this.searchFields.Name = searchDto.Name;
    }

    onSubmit() {
        this.isSubmitted = true;
        if (this.analysisReportForm.valid) {
            this._mApp.ShowLoader();
            let val = this.analysisReportForm.value;
            this._http.post(this._appUrl.UpsertSectionName, val)
                .subscribe(
                    data => {
                        this._mApp.HideLoader();
                        this._toastrService.success(data.json().Result);
                        $('#addAnalysisReportModel').modal('toggle');
                        this.analysisReportForm.reset();
                        this.setPage(this.pager);
                        this.CreateForm();
                    },
                    error => {

                        this._mApp.HideLoader();
                        this._toastrService.error(error.json().Result);
                    }
                )
        }
    }

    Clear() {
        this.analysisReportSearchForm.reset();
    }

    OnReset() {
        this.analysisReportSearchForm.reset();
        this.searchFields.CustomerId = 0;
        this.searchFields.SampleTypeId = 0;
        this.searchFields.Name = '';
        this.pager.pageSize = this._mApp.pageSize;
        this.pager.pageIndex = 0;
        this.GetCustomers();
        this.setPage(this.pager);

    }

    GetCustomers() {
        this._http.get(this._appUrl.GetCustomersMinInfoList)
            .subscribe(
                data => {
                    this.lstCustomers = data.json().Result;
                },
                error => {
                    this._toastrService.error(error.json().Result, '')
                }
            )
    }

    GetAnalysisSections(page: any) {
        this._mApp.ShowLoader();
        this.searchFields.PageNo = page.pageIndex;
        this.searchFields.PageSize = page.pageSize;
        this._http.post(this._appUrl.GetAnalysisSectionsList, this.searchFields)
            .subscribe(
                res => {
                    this._mApp.HideLoader();
                    var data = res.json();
                    this.length = data.PageResult.TotalRecords;
                    this.pagedItems = data.Result;
                    this.isNoRecords = !(data.Result.length > 0);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            );
    }

    DeleteSection(id: number) {
        this.id = id;
    }

    DeleteSectionById(id) {
        this.SaveDataInAmplify();
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.DeleteSectionName + id)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result);
                    this.GetDataFromAmpliy();
                    this.setPage(this.pager);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    GetSampleTypes() {
        this._http.get(this._appUrl.GetMinInfoSampleTypes)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstSampleTypes = data.json().Result;
                        this.lstSampleTypes = this.lstSampleTypes.filter(m => m.SampleTypeId != 3);
                    }
                },
                error => {
                    this._toastrService.error(error.json().Result);
                }
            )
    }

    SaveDataInAmplify() {
        this._amplifyService.SetStorage('analysisList', this.analysisReportSearchForm.value);
        this._amplifyService.SetStorage('analysisList_PageNo', this.pager.pageIndex);
        this._amplifyService.SetStorage('analysisList_PageSize', this.pager.pageSize);
    }


    GetDataFromAmpliy() {
        let storedData = this._amplifyService.GetStorage('analysisList');
        if (storedData != undefined && storedData != null) {
            this.analysisReportSearchForm.setValue(storedData);
            this.ConstructSearchData();
        }
        // let savedPageSize = this._amplifyService.GetStorage('analysisList_PageSize');
        // this.pager.pageSize = savedPageSize > 0 ? savedPageSize : this._pagerService.pageSize;
        let pageIndex = this._amplifyService.GetStorage('analysisList_PageNo');
        if (pageIndex != null && pageIndex != '' && pageIndex != undefined)
            this.pager.pageIndex = pageIndex;
        else
            this.pager.pageIndex = 0;
    }

    ClearDataInAmplify() {
        this._amplifyService.ClearStorage('analysisList');
        this._amplifyService.ClearStorage('analysisList_PageNo');
        this._amplifyService.ClearStorage('analysisList_PageSize');
    }
}